<template>
  <v-card class="elevation-0">
    <v-card-text>
      <v-layout row>
        <v-flex xs6 class="pr-3">
          <v-text-field label="Name" v-model="profileForm.name"></v-text-field>
          <v-text-field label="Surname" v-model="profileForm.surname"></v-text-field>
          <v-text-field label="Company" v-model="profileForm.meta.company"></v-text-field>
          <v-text-field readonly v-if="$is_privilege(['developer'])" v-model="profileForm.dev_key" label="Dev key" :type="show_dev_key ? 'text' : 'password'" :append-icon="show_dev_key ? 'visibility' : 'visibility_off'" append-outer-icon="refresh" @click:append="toggle_dev_key" @click:append-outer="generate_dev_key"></v-text-field>
        </v-flex>
        <v-flex xs6 class="pl-3">
          <v-text-field v-model="changePasswordForm.old_password" label="Old password" type="password"></v-text-field>
          <v-text-field v-model="changePasswordForm.new_password" label="New password" type="password"></v-text-field>
          <v-text-field v-model="changePasswordForm.confirm_password" label="Confirm New password" type="password"></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-text>
      <v-card-actions>
        <v-layout row>
          <v-flex xs6 class="pr-3">
            <v-btn class="orange" dark @click="save">Save</v-btn>
            <v-btn @click="cancel" flat>Cancel</v-btn>
          </v-flex>
          <v-flex xs6 class="pl-3">
            <v-btn class="orange" dark @click="change_password">Change password</v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
  </v-card>
</template>

<script>
import { v4 as uuid } from 'uuid';

export default {
  data () {
    return {
      changePasswordForm: {
        old_password: "",
        new_password: "",
        confirm_password: ""
      },
      profileForm: {
        name: "",
        surname: "",
        meta: {
          company: ""
        }
      },
      checkbox: true,
      show_dev_key: false,
      dev_key_timeout: undefined
    };
  },
  created () {
    this.get_profile()
  },
  methods: {
    toggle_dev_key() {
      this.show_dev_key = !this.show_dev_key;
      if(this.show_dev_key) {
        var self = this;
        this.dev_key_timeout = setTimeout(() => { self.show_dev_key = false; }, 10000);
      } else {
        clearTimeout(this.dev_key_timeout);
      }
    },
    generate_dev_key() {
      this.profileForm.dev_key = "kdk-"+uuid()
    },
    update_profile_form (acc) {
      var account = _.cloneDeep(acc);

      account.meta.company = account.meta.company || "";

      this.profileForm = account;
    },
    get_profile () {
      var self = this;
      this.$store.dispatch("get_profile").then(() => {
        var acc = this.$store.state.account;
        self.update_profile_form(acc);
      }, () => {

      });
    },
    cancel () {
      this.get_profile()
    },
    save () {
      var self = this;
      this.$store.dispatch("update_profile", this.profileForm).then((acc) => {
        this.$message.success("Profile was updated!");
        self.update_profile_form(acc);
      }, (msg) => {
        console.log(msg)
        this.$message.warning("Unable to update profile!");
      });
    },
    clear_form () {
      this.changePasswordForm.old_password = ""
      this.changePasswordForm.new_password = ""
      this.changePasswordForm.confirm_password = ""
    },
    change_password () {
      if (this.changePasswordForm.new_password == this.changePasswordForm.confirm_password) {
        this.$store.dispatch("change_password", this.changePasswordForm).then((response) => {
          this.$message.success("Password was changed!");
          this.clear_form();
        }, (error) => {
          if (error.msg == "invalid_password") {
            this.$message.warning("Old password is invalid!");
          } else if(error.msg == "passwords_dont_match") {
            this.$message.warning("Passwords dont't match!");
          } else {
            this.$message.error("Unable to change password!");
          }
          this.clear_form();
        });
      } else {
        this.$message.warning("Passwords dont't match!");
      }
    }
  }
}
</script>
